import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcTicket(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 8.8a.75.75 0 0 0-1.5 0v1.9a.75.75 0 0 0 1.5 0zM17 13.55a.75.75 0 0 0-1.5 0v1.9a.75.75 0 0 0 1.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25v-2.625h.01a.75.75 0 0 1 .74-.875h.125a1.75 1.75 0 1 0 0-3.5H2.75a.75.75 0 0 1-.74-.875H2zM17 18.5v-.2a.75.75 0 0 0-1.5 0v.2H4.75c-.69 0-1.25-.56-1.25-1.25v-2.06a3.251 3.251 0 0 0 0-6.38V6.75c0-.69.56-1.25 1.25-1.25H15.5v.45a.75.75 0 0 0 1.5 0V5.5h2.25c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25z",
    clipRule: "evenodd"
  }));
}
var IcTicket = createNolIcon(/*#__PURE__*/forwardRef(SvgIcTicket));

export { IcTicket as I };
